import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'HelpTopic';

const HelpTopicApi: any = baseApi(endpoint);

export default HelpTopicApi;